import { Box } from "@mui/material";
import { useContext } from "react";
import { ParagraphText, UBButton } from "../../../../../Libraries";
import moment from "moment";
import { formatNum } from "../../../../../oscar-pos-core/constants";
import { analytics, triggerLogEvent } from "../../../../../config/firebase";
import { LanguageContext } from "../../../../../context/LanguageContext";
import styles from "./ConsumerBillsListing.module.css";

const BillRow = ({ item, onPayBill, onRowClick }) => {
  const [I18n] = useContext(LanguageContext);
  const {
    billing_month,
    consumer_number,
    consumer_number_masked,
    bill_deadline,
    billing_amount,
    "bill__billing_amount": paidBillingAmount,
    billing_status,
    paid_at,
    transaction_details,
  } = item || {};

  // paid_at presence = paid; billing_status "UNPAID" + deadline passed = overdue
  const isPaid = Boolean(paid_at);
  const isClickable = isPaid && !!transaction_details?.id;
  const isOverdue = !isPaid && (billing_status || "").toUpperCase() === "UNPAID"
    && bill_deadline && Date.now() > bill_deadline;
  const isPending = !isPaid && !isOverdue;

  const displayAmount = paidBillingAmount ?? billing_amount ?? 0;
  const displayConsumer = consumer_number_masked || consumer_number || "-";
  
  const displayMonth = billing_month
    ? moment(billing_month, "MMMM YYYY").isValid()
      ? moment(billing_month, "MMMM YYYY").format("MMM YYYY")
      : billing_month
    : "-";

  const displayDueDate = bill_deadline
    ? moment(bill_deadline).format("DD MMM YYYY")
    : "-";

  const paidLabel = paid_at
    ? `${I18n.paid} (${moment(paid_at).format("D MMM YYYY")})`
    : I18n.paid;

  return (
    <Box
      id={`consumer_bills_row_${item?.id ?? consumer_number}`}
      className={`invoiceListTableBody accountTableHeaderMain${isClickable ? " pointer" : ""}`}
      onClick={
        isClickable
          ? () => {
              triggerLogEvent(analytics, "w_bill_txn_transaction_detail");
              onRowClick?.(item);
            }
          : undefined
      }
    >
      <Box className="invListTableHeaderCol fiveColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {displayMonth}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fiveColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {displayConsumer}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fiveColumn textLeft">
        <ParagraphText className="fontSize14 fontWeight400 newFontColor">
          {displayDueDate}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fiveColumn textRight">
        <ParagraphText className={`fontSize14 newFontColor ${isPending ? styles.pendingAmount : ""}`}>
          Rs. {formatNum(Math.abs(displayAmount))}
        </ParagraphText>
      </Box>

      <Box className="invListTableHeaderCol fiveColumn justifyEnd">
        {isPaid ? (
          <ParagraphText className={`fontSize13 fontWeight400 newLightColor`}>
            {paidLabel}
          </ParagraphText>
        ) : isOverdue ? (
          <ParagraphText className={`fontSize13 fontWeight400 newLightColor`}>
            {I18n.not_paid_overdue}
          </ParagraphText>
        ) : (
          <UBButton
            id={`consumer_bills_pay_bill_btn_${item?.id ?? consumer_number}`}
            title={I18n.pay_bill}
            className={`ubButtonStyle ubSecondaryButton textUppercase ${styles.payBillBtn}`}
            onClick={() => {
              triggerLogEvent(analytics, "w_bill_txn_consumer_row_pay");
              onPayBill?.(item);
            }}
          />
        )}
      </Box>
    </Box>
  );
};

export default BillRow;
